<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="page-head">
      <div class="mains-content">
        <div class="ptrb16 align-items">
          <div>门店开支</div>
          <div><el-button type="primary" @click="addClick('')" v-perm="{key: 'invoice', value: 'invoice:add'}">新增开支</el-button></div>
        </div>
        <div class="member-content-box">
          <div class="member-header">
            <div class="align-item ptb16">
              <div class="select-title">开支状态：</div>
              <el-select v-model="query.auditStatus" class="select" placeholder="审核状态" filterable>
                <el-option label="全部状态" value></el-option>
                <el-option label="待审核" value="wait"></el-option>
                <el-option label="审核通过" value="pass"></el-option>
                <el-option label="审核不通过" value="refuse"></el-option>
                <el-option label="已取消" value="cancel"></el-option>
              </el-select>
              <div class="select-title">开支类型：</div>
              <el-select v-model="query.categoryId" class="select" filterable>
                <el-option
                  v-for="(item,index) in options"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <div class="select-title">支出时间：</div>
              <v-date :beginTime="query.beginTime" :endTime="query.endTime" @time="changeDate" class="mr10"></v-date>
              <el-button type="primary" @click="doData">搜索</el-button>
            </div>
          </div>
          <div class="plr16" v-perm="{key: 'invoice', value: 'invoice:list'}">
            <el-table :data="list" :max-height="height - 412" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="categoryIdCn" label="开支类别"></el-table-column>
              <el-table-column prop="amount" label="申请金额"></el-table-column>
              <el-table-column prop="auditAmount" label="审核金额"></el-table-column>
              <el-table-column prop="auditStatusCn" label="审核状态"></el-table-column>
              <el-table-column prop="applyRemark" label="开支明细"></el-table-column>
              <el-table-column prop="invoiceTime" label="发票时间" width="160px">
                <template slot-scope="scope">{{ formatDate(scope.row.invoiceTime) }}</template>
              </el-table-column>
              <el-table-column prop="applyTime" label="申请时间" width="160px">
                <template slot-scope="scope">{{ formatDate(scope.row.applyTime) }}</template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="130">
                <template slot-scope="scope">
                      <!-- <el-link type="primary" v-if="scope.row.auditStatus == 'wait' " @click="calcel(scope.row)">取消</el-link>&nbsp;&nbsp; -->
                      <!-- <el-link type="primary" v-if="scope.row.auditStatus == 'wait'" @click="addClick(scope.row)">编辑</el-link>&nbsp;&nbsp; -->
                      <el-link type="primary" v-perm="{key: 'invoice', value: 'invoice:detail'}" @click="orderDetailPage(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
    <detail-set ref="detailSetForm"  @change="handleChange"></detail-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./edit";
import detailSet from "./detail";
export default {
  data() {
    return {
      authorityKey: 'invoice',
      url: this.$url.invoice.list,
      query: {
        auditStatus: "",
        categoryId: '',
        beginTime: new Date(),
        endTime: new Date(),
        start: 0,
        size: 20
      },
      list: [],
      options: [],
      height: this.$store.getters.MainHeight,
    };
  },
  mixins: [minxin],
  components: {editSet, detailSet },
  computed: {},

  created () {
    this.query.beginTime = this.formatDay(new Date())
    this.query.endTime = this.query.beginTime
    this.totalCounts();
    this.invoiceCategory();
    
  },

  methods: {
    back() {
      this.$router.push("/collectMoney");
    },
    reset () {
      this.query = {
        auditStatus: "",
        categoryId: '',
        beginTime: this.formatDay(new Date()),
        endTime: this.formatDay(new Date()),
        start: 0,
        size: 20
      }
      this.totalCounts();
    },
    changeDate(value) {
      console.log(value);
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
    },
    invoiceCategory() {
      //发票分类
      this.$api.post(this.$url.invoiceCategory.list).then(res => {
        if (res) {
          this.options = res;
          this.options.unshift({id: "",name: "全部类型"})
        }
      });
    },
    addClick(item) {
      if (item && item.id) {
        this.$refs["editSetForm"].$emit("set", item)
      } else {
        this.$refs["editSetForm"].$emit("set")
      }
    },
    orderDetailPage(row) {
      this.$refs["detailSetForm"].$emit("set", row);
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    selectChange() {
      this.totalCounts();
    },
    totalCounts () {
      this.$api.post(this.$url.invoice.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  
  .member-content-box {
    background: #fff;
    border-radius: 10px
  }
  .member-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 16px;
    .setDate {
      margin-right: 15px;
    }
    .top-label {
      width: 90px;
    }
    /deep/ .el-select {
      width: 150px;
      margin-right: 15px;
      /deep/ .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
    .input-with-select {
      width: 150px;
      height: 32px;
      margin-right: 15px;
      /deep/ .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
      /deep/ .el-input__clear {
        font-size: 22px;
        line-height: 32px;
      }
      /deep/ .el-input__prefix {
        color: @blue;
        font-size: 24px;
        margin-right: 10px;
        .el-input__icon {
          line-height: 32px;
        }
      }
    }
  }
}
</style>

